import { axios } from "~/plugins/request"

export function getMessageList(data) {
  return axios({
    method: 'post',
    url: '/im/api/getMessageList',
    data: data
  });
}

export function getStudentInfoByMobileNo(data) {
  return axios({
    method: 'get',
    url: '/studentInfoNew/getStudentInfoByMobileNo' + '?mobileNo=' + data,
    // data: data
  });
}